<script>
import forminput from "../../FormComponet/forminput.vue";

import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrProsesTablo from "@/models/StrProsesTablo.js"; 
import { EventBus } from  "@/main"


export default {
  mixins: [Api, Sabit, StrProsesTablo],
  props: ["Id", "AddEdit","Ustid","Prosesid","Seviye"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,

  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.Get();
    },
  },

  methods: {
    onSubmit() {
      this.$v.$touch();
 
      if (this.AddEdit == "Add") { 
          this.FormData.Prosesid=this.Prosesid;
          this.FormData.Seviye=this.Seviye;
           if (this.Ustid!=null && this.Ustid!=""){
            this.FormData.Ustid=this.Ustid;
           }
          }
       
      if (!this.$v.$invalid) {
       
        if (this.AddEdit == "Add") { 
      
           this.$delete(this.FormData, "Id");
           
              this.Post("StrProsesTablo", this.FormData).then((res) => {
        
                  if (res) {
                      this.$emit("TableUpdate",this.Seviye);
                      EventBus.$emit("TableUpdate",this.Seviye);
                      this.$bvModal.hide("StrProsesTablo");
                  }   
              });

        } else {
         
            this.Update("StrProsesTablo", this.FormData).then((res) => {
                  if (res) {
                    this.$emit("TableUpdate",this.Seviye);
                    this.$bvModal.hide("StrProsesTablo");
                  }
            });

        }
      }
    },
    Get(){
      
    },
    secimsil(kontrol){
      if (kontrol==1){
        this.FormData.SorguId=null;
      }
    }

  },
  created(){      

  }

};
</script>

<template>


  <Loader>

  
  
    <b-modal
      id="StrProsesTablo"
      size="lg"
       :title="this.AddEdit == 'Edit' ? $t('StrProsesTablo.AddEdit.FormTitleEdit')
          : $t('StrProsesTablo.AddEdit.FormTitleAdd')"
      title-class="font-18"
      hide-footer
    >

  
          <Form @submit.prevent="onSubmit">
            
              <div class="row">
                <div class="col-md-12">
                  <forminput
                    :title_position="'d-block'"
                    :labels_lg="4"
                    :FormDataType="FormDataType.Sirano"
                    :Value="FormData.Sirano"
                    :v="$v.FormData.Sirano"
                    @input="FormData.Sirano = $event"
                  />     

                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <forminput
                    :title_position="'d-block'"
                    :labels_lg="4"
                    :FormDataType="FormDataType.Tabloadi"
                    :Value="FormData.Tabloadi"
                    :v="$v.FormData.Tabloadi"
                    @input="FormData.Tabloadi = $event"
                  />     

                </div>
              </div>
                     

              <hr />

              <button class="btn btn-primary" type="submit">{{ $t("StrPerfTablolarDetay.AddEdit.Button") }}</button>
          </Form>


    </b-modal>
  </Loader>
</template>
